<div class="modal-header">
    <h4 class="modal-title">Order No. {{ orderNumber }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  <div class="container">
    <div>
      <div class="row">
        <div class="col-1">
          <ng-icon name="bootstrapBox2Fill" size="2em"></ng-icon>
        </div>
        <div class="col-11">
          <h5 class="mogo-bolder">Product Details</h5>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <table class="table">
            <thead>
              <tr>
                <th scope="col">Product Category</th>
                <th scope="col">Product Description</th>
                <th scope="col">Quantity</th>
                <th scope="col">Weight (kg)</th>
                <th scope="col">Volume (m3)</th>
              </tr>
            </thead>
            <tbody>
              @for(product of productDetails.products; track $index){
                <tr>
                  <td>{{ product.category }}</td>
                  <td>{{ product.description }}</td>
                  <td>{{ product.quantity }}</td>
                  <td>{{ product.weightKg }}</td>
                  <td>{{ product.volumeM3 }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div>
      <div class="row">
        <div class="col-12">
          <h5>Product Category Summary</h5>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <table class="table">
            <thead>
              <tr>
                <th scope="col">Product Category</th>
                <th scope="col">Quantity</th>
                <th scope="col">Weight (kg)</th>
                <th scope="col">Volume (m3)</th>
              </tr>
            </thead>
            <tbody>
              @for(category of productDetails.productCategory; track $index){
                <tr>
                  <td>{{ category.name }}</td>
                  <td>{{ category.quantity }}</td>
                  <td>{{ category.weightKg }}</td>
                  <td>{{ category.volumeM3 }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close('Close click')">Close</button>
</div>
